<div class="badge-container">
	<span class="badge-label"
		[ngClass]="badgeColor">
		{{ badgeLabel }}
	</span>
</div>
